/* eslint-disable no-param-reassign */
/* eslint-disable max-len */
/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import moment from 'moment-timezone';
import { Tooltip as ReactTooltip } from 'react-tooltip';
import Popup from 'reactjs-popup';
import { useSelector, useDispatch } from 'react-redux';
import styled from '@emotion/styled';
import IcomoonReact from 'icomoon-react';
import iconSet from '../../../../shared/images/teambuildr-selection.json';
import Text from '../../../../shared/components/Text/Text';
import {
  setSelectedItems,
  setExpandedItems,
  setActiveModal,
  setIsSupersetPickerOpen,
} from '../../ducks/calendarActions';
import generateUniqueId from '../../../../shared/utils/generateUniqueId';
import SuperSetPickerPopup from './SuperSetPickerPopup';

const SelectedItemsTextAndCheckBoxContainer = styled('div')`
  display: flex;
  background: white;
  align-items: center;
  gap: 8px;
  padding-bottom: ${(props) => (props.itemsAreSelected ? '3px' : '8px')};
  padding-top: ${(props) => (props.itemsAreSelected ? '3px' : '8px')};
  padding-left: ${(props) => (props.itemsAreSelected ? '8px' : '2px')};
  padding-right: ${(props) => (props.itemsAreSelected ? '8px' : '2px')};
  width: fit-content;
  border: ${(props) => (props.itemsAreSelected && '1px solid #EEEEEE')};
  border-radius: 4px;
  box-shadow: ${(props) => (props.itemsAreSelected && '0px 4px 8px 0px #3031331A')};
  margin-top: ${(props) => (props.itemsAreSelected && '10px')};
  margin-bottom: ${(props) => (props.itemsAreSelected && '10px')};

  position: ${(props) => (props.itemsAreSelected && 'sticky')};
  top: ${(props) => (props.itemsAreSelected && '10px')};
  background: ${(props) => (props.itemsAreSelected && 'white')};
  z-index: ${(props) => (props.itemsAreSelected && 50)};

  .checkbox-input {
    appearance: none; /* Remove default checkbox styling */
    min-width: 18px;
    min-height: 18px;
    max-width: 18px;
    max-height: 18px;
    border: 2px solid ${(props) => (props.isChecked ? '#77A7FF' : '#E0E0E0')};
    border-radius: 4px;
    outline: none;
    cursor: pointer;
    position: relative;
  }

  .checkbox-input:checked::after {
    content: '';
    position: absolute;
    top: 1px;
    left: 5px;
    width: 5px;
    height: 10px;
    border: solid ${(props) => (props.isChecked ? '#77A7FF' : '#E0E0E0')};
    border-width: 0 2px 2px 0;
    transform: rotate(45deg);
    display: block;
  }

 .checkbox-input:indeterminate {
    border-color: #77A7FF
  }
  .checkbox-input:indeterminate::after {
    content: '-';
    position: absolute;
    left: 50%;
    transform: translate(-50%, -50%);
    font-size: 31px;
    color: #77A7FF;
    margin-top: 3px;
  }
`;

const IconsWrapper = styled('div')`
display: flex;
`;
const IconContainer = styled('div')`
display: flex;
cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
border-radius: 4px;
height: 32px;
width: 32px;
min-width: 32px;
align-items: center;
justify-content: center;
:hover {
 background: ${(props) => !props.disabled && 'rgba(119, 167, 255, 0.2)'};
}

.icon {
    fill: ${(props) => (props.disabled ? 'rgba(189, 189, 189, 0.5)' : 'rgba(189, 189, 189, 1)')};
  }

  &:hover .icon  {
    fill: ${(props) => !props.disabled && '#77A7FF'};
  }

`;

const Divider = styled('div')`
display: flex;
height: 100%;
width: 1px;
background-color: #EEEEEE;
margin-left: 5px;
margin-right: 5px;
`;

const SelectedItemsTextAndCheckBoxContainerWrapper = ({ dayKey }) => {
  const dispatch = useDispatch();
  const [expandAll, setExpandAll] = useState(false);
  const viewType = useSelector((state) => state.calendar.data.viewType);
  const programType = useSelector((state) => state.calendar.data.programType);
  const selectedItems = useSelector((state) => state.calendar.data.selectedItems);
  const selectedDate = useSelector((state) => state.calendar.data.selectedDate);
  const date = new Date(selectedDate);
  const endpointFormattedDate = moment(dayKey || date).format('YYYY-MM-DD');

  /** here we are conditionally setting calendar items to the true calendar items or
     * the non date based items. We are doing it here so we don't have to write conditionals
     * everywhere we use calendarItems
     */
  const selectedProgramDayNumber = useSelector(
    (state) => state.calendar.data.selectedProgramDayNumber,
  );
  const nonDateBasedProgramItems = useSelector(
    (state) => state.calendar.data.nonDateBasedProgramItems,
  );
  const calendarItems = programType === 'free-form-program'
    ? useSelector((state) => state.calendar.data.nonDateBasedProgramItems[
      dayKey || selectedProgramDayNumber
    ]?.exercises || [])
    : useSelector((state) => state.calendar.data.calendarItems[
      endpointFormattedDate
    ]?.exercises || []);

  const selectedItemsForDayKey = Object.fromEntries(
    (calendarItems || [])
      .filter((item) => selectedItems?.[item.assignedId])
      .map((item) => [item.assignedId, selectedItems[item.assignedId]]),
  ) || {};

  const isSuperSetDisabled = Object.values(selectedItemsForDayKey || {}).some(
    (item) => item?.type === 'session_break' || item?.type === 'questionnaire',
  );

  const itemIsSelected = (cbItem) => !!selectedItemsForDayKey[cbItem.assignedId];

  /** Calculate if all items are selected for dayKey */
  const allSelected = calendarItems.length > 0
  && Object.keys(selectedItemsForDayKey).length === calendarItems.length
  && calendarItems.every(itemIsSelected);

  /** Calculate if some items are selected */
  const someSelected = calendarItems.some((item) => itemIsSelected(item)) && !allSelected;

  /** Build matching items based on current calendar items */
  const matchingItems = {};
  calendarItems.forEach((item) => {
    if (selectedItems[item.assignedId]) {
      matchingItems[item.assignedId] = selectedItems[item.assignedId];
    }
  });

  useEffect(() => {
    if (calendarItems?.length) {
      setSelectedItems({
        ...selectedItems,
        ...matchingItems,
      });
    }
  }, [calendarItems]);

  /** Handle parent checkbox toggle */
  const handleParentCheckboxChange = (event) => {
    event.stopPropagation();

    if (allSelected) {
      const remaining = { ...selectedItems };

      /** Remove only selected items for this dayKey */
      Object.keys(selectedItemsForDayKey).forEach((key) => {
        delete remaining[key];
      });

      dispatch(setSelectedItems(remaining));
    } else {
      const allItemsObj = {};
      calendarItems.forEach((item) => {
        allItemsObj[item.assignedId] = item;
      });
      dispatch(setSelectedItems({
        ...selectedItems,
        ...allItemsObj,
      }));
    }
  };

  const handleExpandExercises = () => {
    const newExpandedItems = {};
    Object.keys(selectedItemsForDayKey).forEach((exercise) => {
      newExpandedItems[exercise] = !expandAll;
    });
    dispatch(setExpandedItems(newExpandedItems));
  };

  const icons = [
    {
      id: generateUniqueId()?.toString(),
      label: expandAll ? 'Collapse' : 'Expand',
      name: expandAll ? 'collapse' : 'expand2',
      color: '#BDBDBD',
      onClick: () => {
        setExpandAll(!expandAll);
        handleExpandExercises();
      },
    },
    {
      id: generateUniqueId()?.toString(), label: 'Superset', name: 'superset', color: '#BDBDBD', onClick: () => {},
    },
    /** Hiding copy icon for now, we will wire this up at a later date */
    {
      id: generateUniqueId()?.toString(),
      label: 'Copy',
      name: 'duplicate',
      color: '#BDBDBD',
      onClick: () => {
        const modalData = {
          preSelectedItems: selectedItemsForDayKey,
          skipFirstSlide: true,
        };

        // Add source day metadata for Program Library mode
        if (programType === 'free-form-program' && nonDateBasedProgramItems) {
          const effectiveDayNumber = dayKey || selectedProgramDayNumber;
          const dayData = nonDateBasedProgramItems[effectiveDayNumber];
          if (dayData) {
            modalData.sourceDayNumber = effectiveDayNumber;
            modalData.sourceWeekNumber = dayData.weekNumber;
            modalData.sourceDayInWeek = dayData.dayInWeek;
          }
        }

        dispatch(setActiveModal('copyWorkoutModal', modalData));
      },
    },
    {
      id: generateUniqueId()?.toString(),
      label: 'Delete',
      name: 'delete',
      color: '#BDBDBD',
      onClick: () => {
        const selectedItemArray = Object.values(selectedItemsForDayKey || {});
        if (!selectedItemArray.length) return;

        /** Split selected items into preSave vs non-preSave */
        const preSaveItems = selectedItemArray.filter((item) => item.preSave);
        const nonPreSaveItems = selectedItemArray.filter((item) => !item.preSave);

        dispatch(setActiveModal('confirmDeleteModal', {
          isBulkDelete: true,
          bulkDeleteAssignedIds: nonPreSaveItems.map((item) => item.assignedId),
          ...(programType === 'calendar' && { date: endpointFormattedDate }),
          ...(programType === 'free-form-program' && { dayNumber: dayKey || selectedProgramDayNumber }),
          preSaveItems,
        }));
      },
    },
  ];

  return (
    <SelectedItemsTextAndCheckBoxContainer isChecked={allSelected} itemsAreSelected={Object?.keys(matchingItems)?.length}>
      <input
        ref={(el) => {
          if (el) {
          /** Set indeterminate state programmatically */
            el.indeterminate = someSelected;
          }
        }}
        className='checkbox-input'
        type='checkbox'
        name='selectedItems'
        checked={allSelected}
        onClick={handleParentCheckboxChange}
      />
      <Text color={Object.keys(matchingItems)?.length ? '#77A7FF' : '#9E9E9E'} fontWeight={Object.keys(matchingItems)?.length && 700}>
        {`Selected (${Object.keys(matchingItems)?.length})`}
      </Text>
      {Object.keys(matchingItems)?.length ? (
        <>
          <Divider />
          <IconsWrapper>
            {icons.map((icon) => (
              <>
                {icon.label === 'Superset' ? (
                  <Popup
                    position='bottom left'
                    arrow={false}
                    offsetX={-4}
                    on='click'
                    onOpen={() => dispatch(setIsSupersetPickerOpen(true))}
                    onClose={() => dispatch(setIsSupersetPickerOpen(false))}
                    trigger={(
                      <IconContainer disabled={isSuperSetDisabled} key={icon.name} onClick={icon.onClick} data-tooltip-id={icon.id}>
                        <IcomoonReact
                          iconSet={iconSet}
                          size={30}
                          icon={icon.name}
                          className='icon'
                        />
                      </IconContainer>
                      )}
                  >
                    {(close) => (
                      !isSuperSetDisabled && (
                      <SuperSetPickerPopup
                        content={{ isMultiSelect: true, selectedIems: selectedItemsForDayKey }}
                        left={0}
                        top={0}
                        bulkActionPicker
                        closeBulkActionPicker={close}
                        effectiveDate={viewType === 'weekView' ? endpointFormattedDate : null}
                        dayNumber={viewType === 'weekView' ? dayKey : null}
                      />
                      )
                    )}
                  </Popup>
                ) : (
                  <IconContainer key={icon.name} onClick={icon.onClick} data-tooltip-id={icon.id}>
                    <IcomoonReact
                      iconSet={iconSet}
                      size={16}
                      icon={icon.name}
                      className='icon'
                    />
                  </IconContainer>
                )}
                {icon.label !== 'Superset' && !isSuperSetDisabled && (
                <ReactTooltip
                  id={icon.id}
                  place='top'
                  content={icon?.label === 'Copy' ? 'Copy Selected Items' : icon?.label}
                  style={{
                    backgroundColor: 'rgba(68, 68, 68, 1)',
                    color: 'white',
                    fontFamily: 'Nunito Sans',
                    fontSize: '13px',
                  }}
                />
                )}
              </>
            ))}
          </IconsWrapper>
        </>
      ) : null}
    </SelectedItemsTextAndCheckBoxContainer>
  );
};

export default SelectedItemsTextAndCheckBoxContainerWrapper;
